import RestModel from './RestModel';

const resourceName = 'cards';

export default {
    list: () => RestModel.list(resourceName),
};
